import { useNavigate } from "react-router";
import { TopBar } from "../components/layout/TopBar";
import { EmptyState } from "../components/shared/EmptyState";
import * as ui from "../styles/ui";
import { TEMPLATES } from "../lib/templates";

export function TemplatesPage() {
  const navigate = useNavigate();
  const templateList = Object.values(TEMPLATES);

  return (
    <>
      <TopBar title="templates" />
      <div style={ui.pageContent}>
        {templateList.length === 0 ? (
          <EmptyState title="no templates available" />
        ) : (
          <div style={styles.grid}>
            {templateList.map(({ type, label, description }) => (
              <div
                key={type}
                style={styles.card}
                role="button"
                tabIndex={0}
                onClick={() => navigate(`/doc/new?template=${type}`)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    navigate(`/doc/new?template=${type}`);
                  }
                }}
              >
                <h3 style={styles.cardTitle}>{label}</h3>
                <p style={styles.cardDesc}>{description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

const styles: Record<string, React.CSSProperties> = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "var(--space-4)",
    maxWidth: 720,
  },
  card: {
    background: "var(--comp-paper)",
    border: "1px solid var(--comp-rule)",
    borderRadius: 0,
    padding: "var(--space-3)",
    display: "flex",
    flexDirection: "column",
    gap: 4,
    cursor: "pointer",
    transition: "border-color 0.15s, background 0.15s",
  },
  cardTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: "var(--fg-1)",
  },
  cardDesc: {
    fontSize: 12,
    color: "var(--fg-3)",
    lineHeight: 1.5,
  },
};
